var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.756,
    height: 71.757,
    viewBox: "0 0 71.756 71.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zoeken",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M71.082,67.853,52.556,49.623A29.3,29.3,0,0,0,60.388,29.71,29.955,29.955,0,0,0,30.2,0,29.952,29.952,0,0,0,.006,29.71,29.952,29.952,0,0,0,30.2,59.42a30.362,30.362,0,0,0,19-6.635l18.6,18.3a2.348,2.348,0,0,0,3.284,0A2.262,2.262,0,0,0,71.082,67.853Zm-40.886-13A25.344,25.344,0,0,1,4.651,29.71,25.344,25.344,0,0,1,30.2,4.571,25.344,25.344,0,0,1,55.741,29.71,25.344,25.344,0,0,1,30.2,54.849Z",
    transform: "translate(-0.006 0)",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/MagnifyingGlass.aa25c4b3662fe5b24b8765fa35d8ffa1.svg";
export { ForwardRef as ReactComponent };